<template>
  <div class="w-full h-screen overflow-hidden relative">

  <logout-component @closeModal="logOutTap=false" @logOut="logOut" v-if="logOutTap" />

    <!-- modal region non autorisé -->
    <div v-if="loadingAccueil && villeNotAccept"
      class="w-full h-full absolute bg-black bg-opacity-70 z-[60] flex items-center justify-center">
      <div class="lg:w-6/12 md:w-8/12 w-[95%] p-6 bg-white space-y-5 rounded-lg">
        <div class="capitalize text-3xl font-bold">
          <p>oups</p>
        </div>
        <div class="text-lg font-light">
          <p>{{ $t('messageVilleNoAccept') }}.</p>
        </div>
        <div class="w-full grid md:grid-cols-2">
          <div class="hidden md:block">
            <img src="/images/map.jpg" class="h-40 object-cover object-center" alt="">
          </div>

          <div class="flex space-x-2 justify-center items-center">
            <div class="h-10 w-32 group rounded overflow-hidden border-green-500 border duration-500 bg-transparent ">
              <button @click="contactService"
                class="w-full h-full hidden  group-hover:flex justify-center items-center">
                <img src="/icons/whatsapp.png" class="w-9 h-9" alt="">
              </button>
              <button class="w-full h-full bg-green-500 text-white hover:text-green-500  hover:bg-transparent  "
                type="button">{{ $t('contacteznous') }}</button>
            </div>
            <div
              class="h-10 w-32  rounded overflow-hidden  flex justify-center items-center duration-500 bg-transparent ">
              <div v-if="GeoLoading" class="w-full h-full flex justify-center items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-loader animate-spin ease-linear  text-[#FF9900]">
                  <line x1="12" y1="2" x2="12" y2="6"></line>
                  <line x1="12" y1="18" x2="12" y2="22"></line>
                  <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                  <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                  <line x1="2" y1="12" x2="6" y2="12"></line>
                  <line x1="18" y1="12" x2="22" y2="12"></line>
                  <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                  <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                </svg>
              </div>
              <button v-else @click="meGeolocaliser"
                class="px-3 py-2 bg-[#FF9900] text-white  rounded-lg  border-[1px] border-transparent " type="button">{{
                  $t('reessayer') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- loading -->
    <div v-if="!loadingAccueil" class="w-full h-screen flex items-center bg-white dark:bg-[#1B1A1D]  absolute z-[60]">
      <div class=" mx-auto relative flex items-center">
        <div id="page">
          <div id="container">
            <div id="ring"></div>
            <div id="ring"></div>
            <div id="ring"></div>
            <div id="ring"></div>
            <img class="h-20 mx-auto" src="/logo/mel_logo_noir.png" alt="" srcset="">
          </div>
        </div>
      </div>
    </div>
    <!-- accept cookies -->
    <!-- <div class="lex items-center text-white bg-[#1B1A1D]  absolute z-[60]">
      <div class=" mx-auto relative flex items-center ">
        <button @click="getLocation">Obtenir ma position</button>
          <p v-if="errorMessage" style="color: red">{{ errorMessage }}</p>
      </div>
    </div> -->
    <!-- Message ajuster l'heure -->
    <div v-if="showMessageConfigHours && loadingAccueil"
      class="w-full h-screen bg-[#2A2742] absolute z-[60] flex justify-center items-center">
      <div>
        <div class="w-auto flex justify-center relative">
          <div class="w-[400px] h-[300px] border-[1px] border-[#2A2742]  absolute z-10"></div>
          <div class="w-[400px] h-[300px]">
            <img src="/images/horloge.gif" alt="" srcset="">
          </div>
        </div>
        <div class="flex w-auto justify-center px-[0.1rem]">
          <div class="lg:w-[80%] flex justify-center">
            <p class="text-white text-center">{{ $t('pasaheure') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Accueil -->
    <div v-if="!showMessageConfigHours && loadingAccueil" class="w-full h-full relative">
      <div class="w-full absolute z-50">
        <div :class="hidmenu || hidnotification ? 'h-screen' : 'h-16'" class="w-full fixed top-0">
          <div :class="hidmenu || hidnotification ? 'h-16' : 'h-full'" class="w-full z-50 relative">
            <nav class="w-full h-full bg-white dark:bg-[#1B1A1D] absolute flex items-center z-50">
              <div class="xl:w-[8%] lg:w-[10%] md:w-[12%] w-[15%] h-full  flex items-center">
                <div class="w-full h-[80%]  flex items-center">
                  <router-link to="/">
                    <img src="/logo/mel_logo_noir.png" class="mx-auto w-[50%] md:mb-2" />
                  </router-link>
                </div>
              </div>
              <div class="w-[36%] hidden h-full xl:flex items-center">
                <div class="w-full h-[80%] flex items-center border-l-[1px] border-r-[1px] border-gray-200">
                  <div class="mx-auto w-full link flex justify-between">
                    <router-link to="/"
                      class="mx-auto border-b-[4px] border-transparent font-arial dark:text-white transition duration-500">{{
                        $t('accueil') }}</router-link>
                    <router-link to="/encheres" @click="openEnchere"
                      class="mx-auto border-b-[4px] border-transparent font-arial dark:text-white transition duration-500">{{
                        $t('encheres') }}</router-link>
                    <router-link to="/boutiques" @click="openAllBoutiques"
                      class="mx-auto border-b-[4px] border-transparent font-arial dark:text-white transition duration-500">{{
                        $t('boutiques') }}</router-link>
                    <router-link to="/contactez-nous"
                      class="mx-auto font-arial dark:text-white transition duration-500 border-b-[4px] border-transparent">{{
                        $t('contacteznous') }}</router-link>
                  </div>
                </div>
              </div>
              <div
                :class="auth ? 'xl:w-[43%] lg:w-[70%] md:w-[68%] w-[65%]' : 'xl:w-[36%] lg:w-[65%] md:w-[63%] w-[60%]'"
                class=" h-full flex items-center">
                <div
                  class="w-full h-[80%] flex items-center px-1 md:px-3 border-l-[1px] xl:border-l-[0px] border-r-[1px] border-gray-200 group">
                  <div class="mx-auto xl:w-[91%] md:w-[91%] w-[80%] relative  rounded-full overflow-hidden group ">
                    <form @submit.prevent="openPageSearch()" class="w-full h-full">
                      <div id="content-filter"
                        class="absolute flex right-0 w-[40%] md:w-[25%] h-full transition-all duration-1000">
                        <div id="filter"
                          class="bg-gray-200 flex w-full place-self-end h-full cursor-pointer border group-focus-within:border-b-[#FF9900] group-focus-within:border-t-[#FF9900] overflow-hidden rounded-bl-none rounded-tl-none">
                          <div v-if="activeFilter == false" @click="openSelectFilter"
                            class="w-full h-full flex items-center">
                            <img class="md:w-5 md:h-5 w-3 h-3 mx-auto" src="/icons/sorting.png" alt="" srcset="">
                          </div>
                          <div @click="changeFilter('articles')" v-if="activeFilter"
                            :class="filterSelect == 'articles' ? 'bg-[#FF9900] text-white' : 'bg-transparent'"
                            class="w-1/2 p-2 h-full xl:hover:bg-[#FF9900] xl:hover:text-white flex items-center justify-center text-[0.6rem] md:text-base">
                            <p class="opacity-0 choix first-letter:uppercase transition-all duration-1000">
                              {{ $t('articles') }}</p>
                          </div>
                          <div @click="changeFilter('boutiques')" v-if="activeFilter"
                            :class="filterSelect == 'boutiques' ? 'bg-[#FF9900] text-white' : 'bg-transparent'"
                            class="w-1/2 p-2 h-full xl:hover:bg-[#FF9900] xl:hover:text-white flex items-center justify-center text-[0.6rem] md:text-base border-l-[1px] border-white">
                            <p class="opacity-0 choix transition-all duration-1000">{{ $t('boutiques') }}</p>
                          </div>
                        </div>
                        <button :disabled="this.loadArticle == 'oui' ? true : false" type="submit" @click="search"
                          id="btn-search"
                          class="bg-[#FF9900] w-16 h-full flex-auto px-1 flex items-center cursor-pointer  overflow-hidden">
                          <img class="md:w-5 md:h-5 w-3 h-3 mx-auto" src="/icons/search.png" alt="" srcset="">
                        </button>
                      </div>
                      <input @keyup="cleanSearch" v-model="mot.value" type="text"
                        class="h-full  md:w-[85%] w-[60%] bg-gray-100 border border-white flex-1 rounded-l-full  text-sm  focus:ring-[#FF9900] focus:border-b-[#FF9900] focus:border-t-[#FF9900] focus:border-l-[#FF9900] block  p-2  placeholder-gray-400 focus:outline-none "
                        :placeholder="$t('recherchez')" :disabled="this.loadArticle == 'oui' ? true : false" />
                    </form>
                  </div>
                  <div class="md:w-[9%] w-[20%] h-full flex items-center">
                    <div @click="openPanier" class="mx-auto cursor-pointer flex">
                      <div class="w-full h-full flex items-center">
                        <svg
                          class="md:w-5 md:h-5 w-4 h-4 mx-auto fill-[#727272] dark:fill-white transition duration-500"
                          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 208 208" version="1.1">
                          <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                              d="M 5.664063 0 C 1.324219 0.617188 -1.722656 4.648438 -1.109375 8.988281 C -0.492188 13.328125 3.539063 16.375 7.878906 15.757813 L 35.207031 15.757813 C 39.734375 15.757813 41.179688 16.648438 42.347656 17.726563 C 43.519531 18.804688 44.996094 20.929688 46.289063 25.359375 C 48.933594 34.316406 83.21875 150.929688 83.21875 150.929688 C 83.28125 151.175781 83.375 151.421875 83.464844 151.667969 C 83.464844 151.667969 92.207031 173.332031 114.242188 173.332031 L 176.042969 173.332031 C 178.875 173.363281 181.519531 171.886719 182.964844 169.425781 C 184.382813 166.960938 184.382813 163.945313 182.964844 161.484375 C 181.519531 159.023438 178.875 157.546875 176.042969 157.574219 L 114.242188 157.574219 C 102.609375 157.574219 97.992188 145.757813 97.992188 145.757813 C 97.992188 145.726563 96.855469 142.09375 96.761719 141.816406 L 160.777344 141.816406 C 168.902344 141.816406 172.5625 135.015625 173.332031 132.460938 L 201.648438 71.648438 C 206.019531 61.121094 203.742188 47.273438 187.613281 47.273438 L 73.371094 47.273438 C 72.046875 47.273438 70.601563 47.609375 69.1875 48.011719 C 66.355469 38.378906 61.890625 22.867188 61.308594 20.929688 C 59.644531 15.296875 57.460938 10.003906 52.9375 5.910156 C 48.410156 1.816406 42.164063 0 35.207031 0 L 7.878906 0 C 7.632813 0 7.386719 0 7.140625 0 C 6.894531 0 6.648438 0 6.402344 0 C 6.15625 0 5.910156 0 5.664063 0 Z M 75.832031 63.523438 L 109.070313 63.523438 L 109.070313 77.558594 L 80.265625 77.558594 L 76.570313 65.738281 C 76.324219 64.875 75.925781 64.109375 75.832031 63.523438 Z M 119.414063 63.523438 L 140.585938 63.523438 L 140.585938 77.558594 L 119.414063 77.558594 Z M 150.929688 63.523438 L 187.367188 63.523438 C 187.273438 64.078125 187.121094 64.570313 186.875 65.246094 L 181.210938 77.558594 L 150.929688 77.558594 Z M 83.464844 87.898438 L 109.070313 87.898438 L 109.070313 101.191406 L 87.652344 101.191406 Z M 119.414063 87.898438 L 140.585938 87.898438 L 140.585938 101.191406 L 119.414063 101.191406 Z M 150.929688 87.898438 L 176.289063 87.898438 L 170.132813 101.191406 L 150.929688 101.191406 Z M 90.851563 111.535156 L 109.070313 111.535156 L 109.070313 125.566406 L 96.023438 125.566406 C 95.714844 125.566406 95.53125 125.476563 95.285156 125.320313 Z M 119.414063 111.535156 L 140.585938 111.535156 L 140.585938 125.566406 L 119.414063 125.566406 Z M 150.929688 111.535156 L 165.453125 111.535156 L 158.808594 125.566406 L 150.929688 125.566406 Z M 110.304688 174.8125 C 102.425781 174.8125 96.023438 181.210938 96.023438 189.089844 C 96.023438 196.96875 102.425781 203.371094 110.304688 203.371094 C 118.183594 203.371094 124.582031 196.96875 124.582031 189.089844 C 124.582031 181.210938 118.183594 174.8125 110.304688 174.8125 Z M 157.574219 174.8125 C 149.695313 174.8125 143.296875 181.210938 143.296875 189.089844 C 143.296875 196.96875 149.695313 203.371094 157.574219 203.371094 C 165.453125 203.371094 171.855469 196.96875 171.855469 189.089844 C 171.855469 181.210938 165.453125 174.8125 157.574219 174.8125 Z " />
                          </g>
                        </svg>
                      </div>
                      <div
                        class="w-4 h-3 transform -translate-y-1 -translate-x-1 -t rounded-full bg-[#FF9900] flex items-center pl-1 pb-[0.1rem]">
                        <p class="text-white text-[0.5rem] h-auto">{{ panier.length }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="auth ? 'xl:w-[13%] md:w-[20%] w-[35%]' : 'xl:w-[20%] w-[25%]'"
                class="  h-full flex items-center">
                <div class="w-full h-[80%] flex items-center xl:px-3 ">
                  <div v-if="auth == false" class="mx-auto flex lg:space-x-4 space-x-2">
                    <router-link to="/login">
                      <button class=" xl:text-lg  px-2 mx-auto h-10 text-center text-sm ">{{ $t('connexion') }}</button>
                    </router-link>
                    <router-link to="/register">
                      <button
                        class="hidden md:block bg-[#FF9900] font-arial rounded-full xl:text-lg text-sm border-[1px] border-transparent hover:border-[#FF9900] hover:bg-transparent hover:text-[#FF9900] text-white px-4 mx-auto h-10 text-center">{{
                          $t('inscriptioncomponent') }}</button>
                    </router-link>
                  </div>
                  <div v-if="auth == true" class="mx-auto flex md:space-x-4 space-x-3">
                    <div @click="hidnotification = !hidnotification"
                      class="relative cursor-pointer h-auto flex items-center">
                      <div class="w-3 h-3 absolute rounded-full bg-[#FF9900] flex items-center -right-1 top-0">
                        <p class="text-[0.5rem] text-white mx-auto">{{ nbreNotificationAndCouponNonLu }}</p>
                      </div>
                      <svg class="w-5 h-5 fill-[#727272] dark:fill-white transition duration-500"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 480 480" version="1.1">
                        <g id="surface1">
                          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                            d="M 236.84375 47.367188 C 219.386719 47.367188 205.261719 61.492188 205.261719 78.949219 L 205.261719 83.574219 C 159.621094 97.140625 126.316406 139.390625 126.316406 189.472656 L 126.316406 233.019531 C 126.316406 275.945313 109.292969 317.023438 78.949219 347.367188 C 70.25 347.367188 63.15625 354.460938 63.15625 363.15625 C 63.15625 371.855469 70.25 378.949219 78.949219 378.949219 L 394.738281 378.949219 C 403.433594 378.949219 410.527344 371.855469 410.527344 363.15625 C 410.527344 354.460938 403.433594 347.367188 394.738281 347.367188 C 364.390625 317.023438 347.367188 275.945313 347.367188 233.019531 L 347.367188 189.472656 C 347.367188 139.390625 314.0625 97.140625 268.421875 83.574219 L 268.421875 78.949219 C 268.421875 61.492188 254.296875 47.367188 236.84375 47.367188 Z M 62.417969 126.128906 C 56.683594 126.4375 51.5625 129.832031 49.035156 135.074219 C 49.035156 135.074219 31.578125 168.441406 31.578125 205.261719 C 31.578125 242.085938 49.035156 275.515625 49.035156 275.515625 C 52.917969 283.285156 62.417969 286.429688 70.1875 282.546875 C 78.023438 278.660156 81.167969 269.160156 77.28125 261.328125 C 77.28125 261.328125 63.15625 231.597656 63.15625 205.261719 C 63.15625 178.925781 77.28125 149.136719 77.28125 149.136719 C 79.871094 144.140625 79.625 138.097656 76.542969 133.347656 C 73.457031 128.597656 68.09375 125.824219 62.417969 126.128906 Z M 410.773438 126.128906 C 405.222656 126.007813 399.980469 128.84375 397.019531 133.53125 C 394.058594 138.28125 393.875 144.203125 396.402344 149.136719 C 396.402344 149.136719 410.527344 178.925781 410.527344 205.261719 C 410.527344 231.597656 396.402344 261.328125 396.402344 261.328125 C 392.515625 269.160156 395.660156 278.660156 403.433594 282.546875 C 411.265625 286.429688 420.765625 283.285156 424.652344 275.515625 C 424.652344 275.515625 442.105469 242.085938 442.105469 205.261719 C 442.105469 168.441406 424.652344 135.074219 424.652344 135.074219 C 422.058594 129.707031 416.695313 126.253906 410.773438 126.128906 Z M 189.472656 410.527344 C 189.472656 436.675781 210.691406 457.894531 236.84375 457.894531 C 262.992188 457.894531 284.210938 436.675781 284.210938 410.527344 Z " />
                        </g>
                      </svg>
                    </div>
                    <div @click="openProfilOrMenu">
                      <CircleProgressBar class="w-9 h-9 cursor-pointer overflow-hidden" :colorUnfilled="'#FF9900'"
                        :strokeWidth="'10px'" :animationDuration="'3s'" :value="user.point" :max="100">
                        <div v-if="user.avatar == '' || user.avatar == null" class="flex">
                          <p v-for="item in abregeName" :key="item" class=" font-bold uppercase"
                            :style="`color:${item.color}`">{{ item.letter }}</p>
                        </div>
                        <img v-if="user.avatar" class="w-8 h-8 mx-auto object-cover object-center rounded-full "
                          :src="user.avatar" alt="" srcset="">
                        <!-- <img v-if="user.avatar == '' || user.avatar == null" class="w-6 h-6 mx-auto object-cover object-center rounded-full " src="/logo/mel_logo_noir.png" alt="" srcset=""> -->
                      </CircleProgressBar>
                    </div>
                    <div @click="logOutTap = true" class="h-auto flex items-center cursor-pointer">
                      <img class="md:h-8  h-6" src="/icons/shutdow.png" alt="" srcset="">
                    </div>
                  </div>
                </div>
              </div>
            </nav>
            <div class="h-full"></div>
            <div :class="hidAlertEnchere ? 'translate-y-0' : '-translate-y-full'"
              class="w-full z-0 h-10 transform transition duration-1000 bg-top bg-cover bg-no-repeat shadow-md shadow-[#FF9900] flex justify-between px-4 md:px-8 items-center"
              style="background-image: url('/images/bg.png');">
              <div>
                <p class="text-white font-semibold text-xs md:text-base">Direct en cour...</p>
              </div>
              <div class="flex">
                <div @click="accepterEnchere"
                  class="text-white cursor-pointer px-2 py-1 rounded-full bg-[#FF9900] hover:bg-white hover:text-[#FF9900] text-xs md:text-base text-center flex items-center">
                  Participer à cette enchère</div>
                <img @click="refuserEnchere" class="h-9 cursor-pointer" src="/icons/cancel.svg" alt="" srcset="">
              </div>
            </div>
            <div :class="user.status == 'block' ? '-translate-y-full' : '-translate-y-36'"
              class="w-full z-0 h-10 transform border-t transition  duration-1000 bg-top bg-cover bg-no-repeat bg-slate-100 shadow-md shadow-[#FF9900] flex justify-between px-4 md:px-8 py-1 items-center">
              <div class="flex space-x-4 items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-6 h-6 text-red-500">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z" />
                </svg>

                <p class="text-red-500 font-semibold hidden md:block text-xs md:text-base">{{ $t('comptebloque') }}</p>
                <p class="text-red-500 font-semibold md:hidden text-xs md:text-base">{{ $t('comptebloquemobile') }}</p>
              </div>
              <div class="flex h-full">
                <button @click="contactService"
                  class="text-[#FF9900]  px-2 h-full rounded-full border border-[#FF9900] hover:bg-white hover:text-[#FF9900] text-xs md:text-base text-center flex items-center">
                  {{ $t('contacteznous') }}
                </button>
              </div>
            </div>
          </div>
          <div class="w-full relative">
            <transition name="slide-fade">
              <div v-if="hidmenu" class="w-full h-screen relative xl:hidden">
                <div class="linkmobile absolute h-full bg-[#FF9900] z-10 space-y-4">
                  <div class="w-full xl:h-[12%] h-[8%] xl:px-0 flex">
                    <router-link to="/" class="w-full px-3 h-full mx-auto transition duration-500">
                      <div class="w-full h-full flex items-center space-x-4">
                        <img class="md:h-8  h-6" src="/icons/home.png" alt="" srcset="">
                        <p class="text-white block text-lg font-semibold">{{ $t('accueil') }}</p>
                      </div>
                    </router-link>
                  </div>
                  <div class="w-full xl:h-[12%] h-[8%]  xl:px-0  flex">
                    <router-link to="/infoprofil" class="w-full px-3 h-full mx-auto transition duration-500">
                      <div class="w-full h-full flex items-center space-x-4">
                        <img class="md:h-8  h-6" src="/icons/icons8_male_user@2x.png" alt="" srcset="">
                        <p class="text-white block text-lg font-semibold">{{ $t('monprofil') }}</p>
                      </div>
                    </router-link>
                  </div>
                  <div class="w-full xl:h-[12%] h-[8%] xl:px-0 flex">
                    <router-link to="/encheres" class="w-full px-3 h-full mx-auto transition duration-500">
                      <div class="w-full h-full flex items-center space-x-4">
                        <img class="md:h-8  h-6" src="/icons/money.png" alt="" srcset="">
                        <p class="text-white block text-lg font-semibold">{{ $t('encheres') }}</p>
                      </div>
                    </router-link>
                  </div>
                  <div class="w-full xl:h-[12%] h-[8%] xl:px-0 flex">
                    <router-link to="/boutiques" class="w-full px-3 h-full mx-auto transition duration-500">
                      <div class="w-full h-full flex items-center space-x-4">
                        <img class="md:h-8  h-6" src="/icons/shop.png" alt="" srcset="">
                        <p class="text-white block text-lg font-semibold">{{ $t('boutiques') }}</p>
                      </div>
                    </router-link>
                  </div>
                  <div class="w-full xl:h-[12%] h-[8%] xl:px-0 flex">
                    <router-link to="/contactez-nous" class="w-full px-3 h-full mx-auto transition duration-500">
                      <div class="w-full h-full flex items-center space-x-4">
                        <img class="md:h-8  h-6" src="/icons/contact.png" alt="" srcset="">
                        <p class="text-white block text-lg font-semibold w-max">{{ $t('contacteznous') }}</p>
                      </div>
                    </router-link>
                  </div>
                </div>
                <div @click="hidmenu = false" class="w-full h-full backdrop-blur-sm"></div>
              </div>
            </transition>
          </div>
          <div v-if="hidnotification" class="w-full h-full relative backdrop-blur-sm">
            <div
              class="absolute right-0 w-64 max-h-[20rem] bg-white shadow shadow-black overflow-hidden md:right-6  rounded-b-md">
              <div class="w-full flex">
                <div @click="switchComponentNotificationCoupon('notification')"
                  :class="selectNotificationCoupon == 'notification' ? 'bg-[#FF9900] text-white' : 'bg-gray-300'"
                  class="w-1/2 relative cursor-pointer">
                  <div v-if="notificationsnonlu > 0"
                    class="w-4 h-4 text-xs bg-red-500 rounded-full absolute my-auto top-0 bottom-0 right-1 flex items-center justify-center text-white">
                    {{ notificationsnonlu }}</div>
                  <p class="text-sm w-full text-center md:py-1 py-2">Notifications</p>
                </div>
                <div @click="switchComponentNotificationCoupon('coupon')"
                  :class="selectNotificationCoupon == 'coupon' ? 'bg-[#FF9900] text-white' : 'bg-gray-300'"
                  class="w-1/2 relative cursor-pointer">
                  <div v-if="couponsnonlu > 0"
                    class="w-4 h-4 text-xs bg-red-500 rounded-full absolute my-auto top-0 bottom-0 right-3 flex items-center justify-center text-white">
                    {{ couponsnonlu }}</div>
                  <p class="text-sm w-full text-center md:py-1 py-2">Coupons</p>
                </div>
              </div>
              <notification-component v-if="selectNotificationCoupon == 'notification'"
                :notificationsnonlu="notificationsnonlu"></notification-component>
              <coupon-component v-if="selectNotificationCoupon == 'coupon'"
                :couponsnonlu="couponsnonlu"></coupon-component>
            </div>
            <div @click="hidnotification = !hidnotification" class="w-full h-full z-50"></div>
          </div>
        </div>
      </div>
      <div class="w-full h-full relative">
        <!-- alert -->
        <div :class="erreurAlert ? 'translate-x-0' : 'translate-x-[120%]'" :style="`max-width: ${widthMessage}px;`"
          class="transition duration-1000 fixed top-[5rem] right-1 md:right-2 z-[100] flex md:block justify-center">
          <div
            class=" w-full md:w-full px-1 space-x-1 py-3 h-16 flex items-center justify-center bg-red-500  rounded-md z-50">
            <svg class="h-6 flex-shrink-0 object-contain" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 208 208" version="1.1">
              <g id="surface1">
                <path style=" stroke:none;fill-rule:nonzero;fill:#FFFFFF;fill-opacity:1;"
                  d="M 199.246094 158.621094 L 120.027344 21.421875 C 110.332031 4.648438 94.515625 4.648438 84.820313 21.421875 L 5.601563 158.621094 C -4.09375 175.394531 3.847656 189.089844 23.207031 189.089844 L 181.644531 189.089844 C 201 189.089844 208.910156 175.394531 199.246094 158.621094 Z M 91.53125 60.351563 C 94.390625 57.273438 97.992188 55.734375 102.425781 55.734375 C 106.855469 55.734375 110.457031 57.246094 113.320313 60.292969 C 116.121094 63.308594 117.566406 67.125 117.566406 71.710938 C 117.566406 75.617188 111.65625 104.546875 109.6875 125.566406 L 95.4375 125.566406 C 93.714844 104.546875 87.28125 75.617188 87.28125 71.710938 C 87.28125 67.183594 88.730469 63.398438 91.53125 60.351563 Z M 113.105469 160.375 C 110.117188 163.269531 106.546875 164.746094 102.425781 164.746094 C 98.300781 164.746094 94.730469 163.269531 91.746094 160.375 C 88.757813 157.453125 87.28125 153.945313 87.28125 149.789063 C 87.28125 145.664063 88.757813 142.09375 91.746094 139.109375 C 94.730469 136.125 98.300781 134.648438 102.425781 134.648438 C 106.546875 134.648438 110.117188 136.125 113.105469 139.109375 C 116.089844 142.09375 117.566406 145.664063 117.566406 149.789063 C 117.566406 153.945313 116.089844 157.453125 113.105469 160.375 Z " />
              </g>
            </svg>
            <div class="text-white w-max text-center first-letter:uppercase">{{ messageErreurAlert }}</div>
          </div>
        </div>

        <!-- success -->
        <div :class="successAlert ? 'translate-x-0' :'translate-x-[140%]'" :style="`max-width: ${widthMessage}px;`"
          class="transition duration-1000 fixed top-[5rem] right-1 md:right-2 z-[100] flex md:block justify-center">
          <div
            class=" w-full md:w-full px-1 py-3 space-x-1 h-16 flex items-center justify-center bg-green-500 rounded-md z-50">
            <img class="h-8 flex-shrink-0 object-contain" src="/icons/checkwhite.png" alt="" srcset="">
            <div class="text-white w-max text-center first-letter:uppercase">{{ messageSuccessAlert }}</div>
          </div>
        </div>
        <div class="flex flex-col relative w-full h-full">
          <div class="h-16"></div>
          <div id="navbar" class="h-full w-full overflow-y-auto">
            <router-view name="two"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CircleProgressBar } from 'vue3-m-circle-progress-bar';
import NotificationComponent from '../otherComponents/NotificationComponent.vue';
import CouponComponent from '../otherComponents/CouponComponent.vue';
import LogoutComponent from '../otherComponents/LogoutComponent.vue';

export default {
  components: { CircleProgressBar, NotificationComponent, CouponComponent,LogoutComponent },

  data() {
    return {
      selectNotificationCoupon:'notification',
      errorMessage: '',
      auth: false,
      user: '',
      time: [0, 0, 0],
      erreurs: '',
      heure: '',
      size: '',
      hidmenu: false,
      langue: '',
      erreurAlert: '',
      messageErreurAlert: '',
      successAlert: '',
      messageSuccessAlert: '',
      showMessageConfigHours: '',
      loadingAccueil: false,
      panier: [],
      hidnotification: false,
      nbreNotificationAndCouponNonLu: 0,
      notificationsnonlu: 0,
      couponsnonlu: 0,
      activeFilter: false,
      filterSelect: 'articles',
      mot: {
        value: '',
        page: 1
      },
      loadArticle: '',
      music: '',
      hidAlertEnchere: false,
      enchereAlert: {},
      setIntervale: '',
      villeNotAccept: false,
      widthMessage: 0,
      GeoLoading: false,
      logOutTap: false,
    }
  },

  watch: {
    requestAccueil: {
      handler(newValue) {
        this.user = newValue[0]
      },
      deep: true
    },
  },
  beforeRouteLeave() {
    window.emitter.off("reloadNumberCouponNonLu")
    window.emitter.off("reloadNumberNotificationNonLu")
    window.emitter.off("disableSearch")
    window.emitter.off("alertError")
    window.emitter.off("alertSucces")
    window.emitter.off("cleanPanier")
    clearInterval(this.setIntervale)
  },
  created() {
    this.setIntervale = setInterval(this.getNow, 1000);
    window.emitter.on("reloadNumberNotificationNonLu", (data) => {
      this.nbreNotificationAndCouponNonLu -= this.notificationsnonlu
      this.notificationsnonlu = data
    })
    window.emitter.on("reloadNumberCouponNonLu", (data) => {
      this.nbreNotificationAndCouponNonLu -= this.couponsnonlu
      this.couponsnonlu = data
    })
    window.emitter.on("disableSearch", (data) => {
      this.loadArticle = data
    })
    window.emitter.on("cleanPanier", () => {
      this.panier = []
    })
    window.emitter.on("alertError", (data) => {
      this.music ? this.music.pause() : ''
      this.music = new Audio(
        "/music/error.mp3"
      )
      this.music.autoplay = true
      this.erreurAlert = data[0]
      this.messageErreurAlert = data[1]
      setTimeout(() => {
        this.erreurAlert = ''
      }, 5000);
    })
    window.emitter.on("alertSucces", (data) => {
      this.music ? this.music.pause() : ''
      this.music = new Audio(
        "/music/notification.mp3"
      )
      this.music.autoplay = true
      this.successAlert = data[0]
      this.messageSuccessAlert = data[1]
      setTimeout(() => {
        this.successAlert = ''
      }, 5000);
    })
  },
  async mounted() { 
    this.music = new Audio(
      "/music/silent.mp3"
    )
    this.music.autoplay = true

    if (localStorage.getItem('langue') == null || localStorage.getItem('langue') == '' || localStorage.getItem('langue') == false) {
      localStorage.setItem('langue', 'fr')
    }

    localStorage.getItem('langue') != 'en' ? this.$i18n.locale = 'fr' : this.$i18n.locale = 'en'

    if (localStorage.getItem('langue')) {
      this.langue = localStorage.getItem('langue');
    }
    this.size = window.innerWidth
    if (window.innerWidth < 768) {
      this.widthMessage = window.innerWidth * 90 / 100
    } else {
      if (window.innerWidth >= 768 && window.innerWidth < 1280) {
        this.widthMessage = window.innerWidth * 40 / 100
      }
      else {
        this.widthMessage = window.innerWidth * 25 / 100
      }
    }


    this.axios.get(this.requestHttp + 'accueil', {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
      },
    }).then(({ data }) => {

      var today = new Date
      // Comparer les heures
      if (today.getHours() === data[1][0] && (today.getMinutes() >= data[1][1] - 1 && today.getMinutes() <= data[1][1] + 1)) {
        this.showMessageConfigHours = false
        this.time = data[1]
        this.heure = data[1][0]
        this.time[0] = 17 - today.getHours()
        this.time[1] = 59 - this.time[1]
        this.time[2] = 59 - this.time[2]
        this.$store.dispatch('requestAuth', data[data.length - 1])
        if (data[data.length - 1] == 'Auth') {
          this.$store.state.villes.filter(item => item == data[0].ville).length > 0 ? this.villeNotAccept = false : this.villeNotAccept = true
          this.auth = true
          this.panier = data[3]
          this.user = data[0]
          this.$store.state.wallet = data[6]
          this.notificationsnonlu = data[4]
          this.couponsnonlu = data[9]
          this.nbreNotificationAndCouponNonLu = data[4] + data[9]
          this.$store.dispatch('requestFraisServiceVendeur', data[10])
          this.$store.dispatch('requestAccueil', data)
          this.$store.dispatch('requestBannieres', data[7])
          this.$store.dispatch('requestRelai', data[8])

          window.Echo.private('update-wallet.' + this.user.id).listen('EventTransaction.EventTransactionInMyWallet', (e) => {
            this.$store.state.wallet.montant = e['wallet'].montant
            if (e['transaction'].status == 'debit') {
              this.$store.state.alltransaction.length > 0 ? this.$store.state.alltransaction.unshift(e['transaction']) : ''
              this.$store.state.allDebit.length > 0 ? this.$store.state.allDebit.unshift(e['transaction']) : ''
              this.user.wallet = e['wallet']
            }
            if (e['transaction'].status == 'credit') {
              this.$store.state.alltransaction.length > 0 ? this.$store.state.alltransaction.unshift(e['transaction']) : ''
              this.$store.state.allCredit.length > 0 ? this.$store.state.allCredit.unshift(e['transaction']) : ''
              this.user.wallet = e['wallet']
            }
          })

          window.Echo.private('my-commande.' + this.user.id).listen('EventBoutique.EventMyCommande', (e) => {
            if (this.$store.state.factures.length > 0) {
              this.$store.state.factures.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.factures.splice(index, 1)) : '')
              this.$store.state.factures.unshift(e['commande']);
            }
            if (e['commande'].status == 'en cour livraison') {
              if (this.$store.state.facturesEnCoursLivraison.length > 0) {
                this.$store.state.facturesEnCoursLivraison.unshift(e['commande']);
              }
              this.$store.state.nbrEnCourLivraisonCommande += 1;
            }
            if (e['commande'].status == 'en cour recuperation') {
              this.$store.state.facturesEnCoursLivraison.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursLivraison.splice(index, 1)) : '')
              if (this.$store.state.facturesEnCoursRecuperation.length > 0) {
                this.$store.state.facturesEnCoursRecuperation.unshift(e['commande']);
              }
              this.$store.state.nbrEnCourLivraisonCommande -= 1;
              this.$store.state.nbrEnCourRecuperationCommande += 1;
            }

            if (e['commande'].status == 'annule') {
              this.$store.state.facturesEnCoursLivraison.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursLivraison.splice(index, 1), this.$store.state.nbrEnCourLivraisonCommande -= 1) : '')
              this.$store.state.facturesEnCoursRecuperation.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursRecuperation.splice(index, 1), this.$store.state.nbrEnCourRecuperationCommande -= 1) : '')
              if (this.$store.state.facturesAnnule.length > 0) {
                e['commande'].article.coupon = null
                this.$store.state.facturesAnnule.unshift(e['commande']);
              }
              this.$store.state.nbrAnnuleCommande += 1;
            }

            if (e['commande'].status == 'valide') {
              this.$store.state.facturesEnCoursRecuperation.filter((item, index) => item.id == e['commande'].id ? (this.$store.state.facturesEnCoursRecuperation.splice(index, 1), this.$store.state.nbrEnCourRecuperationCommande -= 1) : '')
              if (this.$store.state.factureValide.length > 0) {
                e['commande'].article.coupon = null
                this.$store.state.factureValide.unshift(e['commande']);
              }
              this.$store.state.nbrEnCourRecuperationCommande -= 1;
              this.$store.state.nbrValideCommande += 1;
            }
          })

          window.Echo.private('my-coupon.' + this.user.id).listen('EventBoutique.MyCouponEvent', (e) => {
            var item = [
              e.coupon,
              { en: e.en, fr: e.fr }
            ]
            this.couponsnonlu += 1
            this.nbreNotificationAndCouponNonLu += 1
            this.music ? this.music.pause() : ''
            this.music = new Audio(
              "./music/notification.mp3"
            )
            this.music.autoplay = true
            if (this.$store.state.coupons.length > 0) {
              this.$store.state.coupons.unshift(item)
            }
          })

          window.Echo.private('leave-coupon.' + this.user.id).listen('EventBoutique.LeaveCouponEvent', (e) => {
            this.$store.state.coupons.filter((item, index) => item[0].id == e.coupon.id ? (this.$store.state.coupons.splice(index, 1)) : '')
          })

          window.Echo.private('App.Models.User.' + this.user.id).notification((notification) => {
            var item = [
              { data: JSON.stringify(notification.data) },
              { en: notification.en, fr: notification.fr }
            ]

            this.notificationsnonlu += 1
            this.nbreNotificationAndCouponNonLu += 1
            this.music ? this.music.pause() : ''
            this.music = new Audio(
              "./music/notification.mp3"
            )
            this.music.autoplay = true
            if (this.$store.state.notifications.length > 0) {
              this.$store.state.notifications.unshift(item)
            }
          });

          window.Echo.channel('enchere-active-desactive.' + encodeURI(this.user.ville).split("%").join('')).listen('EventEnchere.EnchereActifDesacEvent', (e) => {
            var find = false
            if (JSON.parse(e['enchere']).actif == 1 && JSON.parse(e['enchere']).status != 'termine') {
              window.emitter.emit("alertSucces", ['New enchere', this.$i18n.messages[`${localStorage.getItem('langue')}`].newenchere])
            }
            var value = async () => {
              if (this.$store.state.encheres.length > 0) {
                for (let i = 0; i < this.$store.state.encheres.length; i++) {
                  if (this.$store.state.encheres[i].id == JSON.parse(e['enchere']).id) {
                    find = true
                    this.$store.state.encheres.splice(i, 1)
                    if (JSON.parse(e['enchere']).status == 'direct') {
                      this.$store.state.nbrEnchreDirect -= 1
                    }
                  }
                }
                if (find != true) {
                  this.$store.state.encheres.unshift(JSON.parse(e['enchere']))
                  if (JSON.parse(e['enchere']).status == 'direct') {
                    this.$store.state.nbrEnchreDirect += 1
                  }
                }
              }
            }
            value()
          })

          window.Echo.channel('alert-enchere-direct.' + encodeURI(this.user.ville).split("%").join('')).listen('EventEnchere.AlertEnchereDirectEvent', (e) => {
            this.enchereAlert = JSON.parse(e['enchere'])
            if (this.$store.state.encheres.length > 0) {
              for (let i = 0; i < this.$store.state.encheres.length; i++) {
                if (this.$store.state.encheres[i].id == JSON.parse(e['enchere']).id) {
                  if (this.$store.state.encheres[i].status != JSON.parse(e['enchere']).status) {
                    this.$store.state.encheres[i].status = JSON.parse(e['enchere']).status
                    this.$store.state.nbrEnchreDirect += 1
                  }
                }
              }
            }
            this.hidAlertEnchere = true
            this.music = new Audio(
              "./music/sonnerie_appel.mp3"
            )
            this.music.autoplay = true
            this.music.loop = true
          })

          window.Echo.channel('enchere-termine.' + encodeURI(this.user.ville).split("%").join('')).listen('EventEnchereTermine.EventEnchereTermine', (e) => {
            if (this.$store.state.encheres.length > 0) {
              this.$store.state.encheres.filter((item, index) => item.id == e['enchere'].id ? this.$store.state.encheres[index].status = 'termine' : '')
              this.$store.state.nbrEnchreDirect -= 1
            }

            window.emitter.emit("enchere-termine", e)
          })      
          
          window.Echo.private('block.' + this.user.id).listen('EventBoutique.BlockBoutiqueEvent', () => {
            console.log('block')
            this.user.status == 'block' ? this.user.status = 'approuve' : this.user.status = 'block'
          })

          window.Echo.private('point.' + this.user.id).listen('EventBoutique.PointEvent', (e) => {
            this.$store.state.dataAccueil[0] = e['user']
          })

          window.Echo.private('notation.' + this.user.id).listen('EventBoutique.NotationEvent', (e) => {
            this.$store.state.dataAccueil[0].etoile += e['etoile'].valeur
            this.$store.state.dataAccueil[0].avis += 1
          })
          //instrution pour ecouter et recuperer le signal envoye par l'emetteur
          window.Echo.private('call.' + this.user.id).listen('EventEnchere.CallEvent', (e) => {
            window.emitter.emit("Reponse", e)
          })
        } else {
          localStorage.removeItem('jwtToken')
          this.auth = false
          this.$store.state.villes.filter(item => item == data[4]).length > 0 ? this.villeNotAccept = false : this.villeNotAccept = true
          this.$store.dispatch('requestAccueil', data)
          this.$store.dispatch('requestBannieres', data[5])
          this.$store.dispatch('requestRelai', data[6])
        }
      } else {
        this.showMessageConfigHours = true
      }

      // if (data[1][0] == today.getHours()) {

      // } else {
      //   this.showMessageConfigHours = true
      // }
      this.loadingAccueil = true
    })
      .catch((error) => {
        this.erreurs = error

      });
  },
  methods: {
    getNow() {
      if (this.time.length === 0) return;
      var today = new Date
      let [hours, minutes, seconds] = this.time;

      seconds -= 1;
      if (seconds < 0) {
        seconds = 59;
        minutes -= 1;
        if (minutes < 0) {
          minutes = 59;
          hours = 17 - today.getHours();
          this.heure = today.getHours();
        }
      }
      this.time = [hours, minutes, seconds];
      this.$store.dispatch('requestRealTime', this.time);
      this.$store.dispatch('requestHours', this.heure);
    },
    async getLocation() {
      try {
        let localisation = await this.$geo()
        console.log("Position obtenue :", localisation);
      } catch (error) {
        this.errorMessage = "Veuillez autoriser la géolocalisation pour utiliser cette fonctionnalité.";
      }
    },
    switchComponentNotificationCoupon(value){
      this.selectNotificationCoupon = value
    },
    openPanier() {
      if (localStorage.getItem('jwtToken')) {
        this.$router.push('/panier');
      } else {
        this.$router.push('/login');
      }
    },
    openAllBoutiques() {
      if (localStorage.getItem('jwtToken')) {
        this.$router.push('/boutiques');
      } else {
        this.$router.push('/login');
      }
    },
    openEnchere() {
      if (localStorage.getItem('jwtToken')) {
        this.$router.push('/encheres');
      } else {
        this.$router.push('/login');
      }
    },
    openProfilOrMenu() {
      if (this.size <= 1024) {
        if (this.hidmenu == true) {
          this.hidmenu = false
        } else {
          this.hidmenu = true
        }
      } else {
        this.$router.push('/profil');
      }
    },
    logOut() {
      this.logOutTap = false
      localStorage.removeItem('jwtToken')
      this.auth = false
      this.panier = []
      this.user = {}
      this.$store.state.dataAccueil[3] = []
      this.$router.push('/');
    },
    cleanSearch() {
      if (this.filterSelect == 'articles' && this.mot.value.length == 0) {
        window.emitter.emit("searchElementArticle", this.mot)
      }
      if (this.filterSelect == 'boutiques' && this.mot.value.length == 0) {
        window.emitter.emit("searchElementBoutique", this.mot)
      }
    },
    openPageSearch() {
      if (localStorage.getItem('jwtToken')) {
        if (this.filterSelect == 'articles') {
          this.$router.push('/');
          this.$store.state.scrollFilterAccueil = 1000000
          window.emitter.emit("EventScrollNavBar", 10000000)
        } else {
          this.$router.push('/boutiques');
        }
      } else {
        this.$router.push('/login');
      }
    },
    search() {
      if (this.filterSelect == 'articles') {
        window.emitter.emit("searchElementArticle", this.mot)
      } else {
        window.emitter.emit("searchElementBoutique", this.mot)
      }
      this.openPageSearch()
    },
    openSelectFilter() {
      document.getElementById('content-filter').classList.replace('w-[40%]', 'w-full')
      document.getElementById('content-filter').classList.replace('md:w-[25%]', 'w-full')
      document.getElementById('filter').classList.replace('rounded-bl-none', 'rounded-bl-full')
      document.getElementById('filter').classList.replace('rounded-tl-none', 'rounded-tl-full')
      setTimeout(() => {
        this.activeFilter = true
      }, 500);
      setTimeout(() => {
        var items = document.getElementsByClassName('choix')
        for (let i = 0; i < items.length; i++) {
          items[i].classList.replace('opacity-0', 'opacity-100')
        }
      }, 1000);
    },
    changeFilter(select) {
      var items = document.getElementsByClassName('choix')
      for (let i = 0; i < items.length; i++) {
        items[i].classList.replace('opacity-100', 'opacity-0')
      }
      this.activeFilter = false
      document.getElementById('filter').classList.replace('rounded-tl-full', 'rounded-tl-none')
      document.getElementById('filter').classList.replace('rounded-bl-full', 'rounded-bl-none')
      document.getElementById('content-filter').classList.remove('w-full')
      document.getElementById('content-filter').className += ' w-[40%] md:w-[25%]'
      this.filterSelect = select
      this.openPageSearch()
    },
    refuserEnchere() {
      this.hidAlertEnchere = false
      this.music.pause();
    },
    accepterEnchere() {
      this.music.pause();
      this.music = new Audio(
        "./music/sonnerie_decrocher.mp3"
      )
      this.music.autoplay = true
      this.viewSalonEnchere()
      this.hidAlertEnchere = false
    },
    viewSalonEnchere() {
      this.$router.push({ name: 'salon_enchere', query: { id: this.enchereAlert.id, titre: this.enchereAlert.titre } })
    },
    contactService() {
      this.number = Math.round(Math.random() * (this.requestServiceClient.length - 1))
      if (localStorage.getItem('langue') != 'en') {
        window.open('https://wa.me/' + this.requestServiceClient[this.number].numero + '?text=Salut%20MEL,%20j\'aimerais%20avoir%20une%20assistance.')
      } else {
        window.open('https://wa.me/' + this.requestServiceClient[this.number].numero + '?text=Hi%20MEL,%20I%20would%20like%20some%20help.')
      }
    },
    meGeolocaliser() {
      this.GeoLoading = true
      this.axios.post(this.requestHttp + 'me_geolocaliser', '', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(() => {
        this.GeoLoading = false
        location.reload()
      })
        .catch(error => {
          this.GeoLoading = false
        })
    }
  },
  computed: {
    requestSelectComponentNotificationCoupon() {
      return this.$store.state.selectComponentNotificationCoupon
    },
    requestHttp() {
      return this.$store.state.api
    },
    requestServiceClient() {
      return this.$store.state.servicesClient
    },
    abregeName() {
      var tabName = this.user.name.split(" ")
      var color = ['#FF0000', '#FF9900', '#0080ff ', '#008000 ']
      var abrege = []
      if (tabName.length >= 2) {
        for (let i = 0; i < 2; i++) {
          abrege[i] = {
            letter: tabName[i].slice(0, 1),
            color: color[Math.floor(Math.random() * color.length)]
          }
        }
      } else {
        for (let i = 0; i < 2; i++) {
          abrege[i] = {
            letter: tabName[0][i].slice(0, 1),
            color: color[Math.floor(Math.random() * color.length)]
          }
        }
      }
      return abrege
    },
    requestAccueil() {
      return this.$store.state.dataAccueil
    },
    requestFile() {
      return this.$store.state.apifile
    },
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.8s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

nav .link .router-link-exact-active {
  border-color: rgb(255 153 0 / var(--tw-border-opacity));
  border-bottom-width: 4px;
  color: #FF9900;
}

.linkmobile .router-link-exact-active {
  background-color: rgb(180 109 2 / var(--tw-bg-opacity));
  color: #FF9900;
}

#page {
  display: flex;
  justify-content: center;
  align-items: center;
}

#container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

#h3 {
  color: rgb(82, 79, 79);
}

#ring {
  width: 190px;
  height: 190px;
  border: 1px solid transparent;
  border-radius: 50%;
  position: absolute;
}

#ring:nth-child(1) {
  border-bottom: 8px solid rgb(81, 255, 0);
  animation: rotate1 2s linear infinite;
}

@keyframes rotate1 {
  from {
    transform: rotateX(50deg) rotateZ(110deg);
  }

  to {
    transform: rotateX(50deg) rotateZ(470deg);
  }
}

#ring:nth-child(2) {
  border-bottom: 8px solid rgb(240, 19, 67);
  animation: rotate2 2s linear infinite;
}

@keyframes rotate2 {
  from {
    transform: rotateX(20deg) rotateY(50deg) rotateZ(20deg);
  }

  to {
    transform: rotateX(20deg) rotateY(50deg) rotateZ(380deg);
  }
}

#ring:nth-child(3) {
  border-bottom: 8px solid rgb(255, 255, 0);
  animation: rotate3 2s linear infinite;
}

@keyframes rotate3 {
  from {
    transform: rotateX(40deg) rotateY(130deg) rotateZ(450deg);
  }

  to {
    transform: rotateX(40deg) rotateY(130deg) rotateZ(90deg);
  }
}

#ring:nth-child(4) {
  border-bottom: 8px solid rgb(255, 170, 14);
  animation: rotate4 2s linear infinite;
}

@keyframes rotate4 {
  from {
    transform: rotateX(70deg) rotateZ(270deg);
  }

  to {
    transform: rotateX(70deg) rotateZ(630deg);
  }
}

/* Improving visualization in light mode */
.chaotic-orbit {
  --uib-size: 25px;
  --uib-speed: 1.5s;
  --uib-color: black;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--uib-size);
  width: var(--uib-size);
  animation: rotate936 calc(var(--uib-speed) * 1.667) infinite linear;
}

.chaotic-orbit::before,
.chaotic-orbit::after {
  content: '';
  position: absolute;
  height: 60%;
  width: 60%;
  border-radius: 50%;
  background-color: var(--uib-color);
  will-change: transform;
  flex-shrink: 0;
}

.chaotic-orbit::before {
  animation: orbit var(--uib-speed) linear infinite;
}

.chaotic-orbit::after {
  animation: orbit var(--uib-speed) linear calc(var(--uib-speed) / -2) infinite;
}

@keyframes rotate936 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes orbit {
  0% {
    transform: translate(calc(var(--uib-size) * 0.5)) scale(0.73684);
    opacity: 0.65;
  }

  5% {
    transform: translate(calc(var(--uib-size) * 0.4)) scale(0.684208);
    opacity: 0.58;
  }

  10% {
    transform: translate(calc(var(--uib-size) * 0.3)) scale(0.631576);
    opacity: 0.51;
  }

  15% {
    transform: translate(calc(var(--uib-size) * 0.2)) scale(0.578944);
    opacity: 0.44;
  }

  20% {
    transform: translate(calc(var(--uib-size) * 0.1)) scale(0.526312);
    opacity: 0.37;
  }

  25% {
    transform: translate(0%) scale(0.47368);
    opacity: 0.3;
  }

  30% {
    transform: translate(calc(var(--uib-size) * -0.1)) scale(0.526312);
    opacity: 0.37;
  }

  35% {
    transform: translate(calc(var(--uib-size) * -0.2)) scale(0.578944);
    opacity: 0.44;
  }

  40% {
    transform: translate(calc(var(--uib-size) * -0.3)) scale(0.631576);
    opacity: 0.51;
  }

  45% {
    transform: translate(calc(var(--uib-size) * -0.4)) scale(0.684208);
    opacity: 0.58;
  }

  50% {
    transform: translate(calc(var(--uib-size) * -0.5)) scale(0.73684);
    opacity: 0.65;
  }

  55% {
    transform: translate(calc(var(--uib-size) * -0.4)) scale(0.789472);
    opacity: 0.72;
  }

  60% {
    transform: translate(calc(var(--uib-size) * -0.3)) scale(0.842104);
    opacity: 0.79;
  }

  65% {
    transform: translate(calc(var(--uib-size) * -0.2)) scale(0.894736);
    opacity: 0.86;
  }

  70% {
    transform: translate(calc(var(--uib-size) * -0.1)) scale(0.947368);
    opacity: 0.93;
  }

  75% {
    transform: translate(0%) scale(1);
    opacity: 1;
  }

  80% {
    transform: translate(calc(var(--uib-size) * 0.1)) scale(0.947368);
    opacity: 0.93;
  }

  85% {
    transform: translate(calc(var(--uib-size) * 0.2)) scale(0.894736);
    opacity: 0.86;
  }

  90% {
    transform: translate(calc(var(--uib-size) * 0.3)) scale(0.842104);
    opacity: 0.79;
  }

  95% {
    transform: translate(calc(var(--uib-size) * 0.4)) scale(0.789472);
    opacity: 0.72;
  }

  100% {
    transform: translate(calc(var(--uib-size) * 0.5)) scale(0.73684);
    opacity: 0.65;
  }
}
</style>